import { render, staticRenderFns } from "./gongGeSetting.vue?vue&type=template&id=5e479520&scoped=true&"
import script from "./gongGeSetting.vue?vue&type=script&lang=js&"
export * from "./gongGeSetting.vue?vue&type=script&lang=js&"
import style0 from "./gongGeSetting.vue?vue&type=style&index=0&id=5e479520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e479520",
  null
  
)

export default component.exports